export default __webpack_public_path__ + "static/media/logo.397076a9.svg";